'use strict';

import { AlarmVehicle } from "../../../../data/alarm.data";
import PrivilegeService from "../../../../services/privilege.service";
import {RolePrivilege} from "../../../../data/privileges.enum";

require('./alarm.vehicles.component.css');

//alarmEinsatzmittel
export default class AlarmVehiclesComponent {
  public restrict: any;
  public template: any;
  public scope: any;
  public controllerAs: string;
  public bindToController: boolean;
  public controller: any;

  constructor() {
    this.restrict = 'E';
    this.template = require('./alarm.vehicles.component.html');
    this.scope = {
      alarm: '='
    };
    this.controllerAs = 'ctrl';
    this.bindToController = true;
    this.controller = AlarmVehiclesComponentController;

  }
}

class AlarmVehiclesComponentController {
  private $uibModal;
  public hasVehicleDetails: boolean;
  constructor($uibModal, private privilegeService:PrivilegeService) {
    this.hasVehicleDetails = privilegeService.has(RolePrivilege.Station_Vehicles_ReadDetails);
    this.$uibModal = $uibModal;
  }

  openVehicle(vehicle: AlarmVehicle) {
    this.$uibModal.open({
      template: require('./../../../modals/wache/vehicle.modal/vehicle.modal.html'),
      controller: 'VehicleModalController',
      controllerAs: 'ctrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        vehicle: () => {
          return undefined;
        },
        vehicleId: () => {
          return vehicle.vehicleId;
        },
        okFunction: () => {

        }
      }
    });
  }
}